import React from "react";
import { ImageFit } from "@fluentui/react";
import { IconButton, PrimaryButton } from "@fluentui/react/lib/Button";
import { formatMessageDefault } from "../../../utils/helpers/LanguageHelper";
import { ButtonVariants } from "../../../styles/fluent/ButtonVariants";

export interface OutlineSearchFooterProps {
  disabled: boolean;
  onClick: () => void;
}

export const OutlineSearchFooter: React.FC<OutlineSearchFooterProps> = ({ disabled, onClick }) => {
  const editLabel = formatMessageDefault("cof.outline.search.edit", "Edit");
  return (
    <>
      <div
        className="ms-hiddenSm"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "5px",
        }}
      >
        <PrimaryButton text={editLabel} disabled={disabled} onClick={onClick} className={ButtonVariants.primary} />
      </div>
      <div
        className="ms-hiddenMdUp"
        style={{
          gap: ".25rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          width: "100%",
        }}
      >
        <IconButton
          title={editLabel}
          disabled={disabled}
          onClick={onClick}
          styles={{
            icon: { height: "1.5rem" },
            root: {
              backgroundColor: disabled ? "#D0D0D0" : null,
              opacity: disabled ? 0.5 : 1,
            },
          }}
          iconProps={{
            imageProps: {
              src: "/assets/edit.svg",
              imageFit: ImageFit.contain,
              width: "1.5rem",
              height: "1.5rem",
            },
          }}
        />
      </div>
    </>
  );
};
